import React, { useEffect, useState } from 'react';

const UseCars = () => {
    const [products, setProducts] = useState([]);
    
    useEffect(() => {
        fetch('https://vast-mesa-37329.herokuapp.com/items')
            .then(res => res.json())
            .then(data => setProducts(data))
    }, [])
    return [products,setProducts]
};

export default UseCars;